import { useCallback, useEffect, useRef } from "react";
import { useApolloClient, useMutation } from "@apollo/client";
import { UserContentType } from "@onmo/graphql/graphql";
import {
  completeContentViewGQL,
  getUserProfileTgpGQL,
  meGQL,
  startContentViewGQL,
} from "../graphql";

export const useVideoContentView = (isPlayingVideo?: boolean) => {
  const client = useApolloClient();
  const [startContentView] = useMutation(startContentViewGQL);
  const [completeContentView] = useMutation(completeContentViewGQL);
  const contentViewIdRef = useRef<string | null>(null);

  useEffect(() => {
    if (!isPlayingVideo) return;
    let cancelled = false;

    contentViewIdRef.current = null;
    startContentView({
      variables: { input: { contentType: UserContentType.Video } },
    })
      .then((contentView) => {
        if (cancelled) return;
        contentViewIdRef.current =
          contentView?.data?.startContentView?.contentId ?? null;
      })
      .catch(() => {
        //do nothing
      });

    return () => {
      cancelled = true;
    };
  }, [isPlayingVideo, startContentView]);

  return useCallback(async () => {
    const contentId = contentViewIdRef.current;
    if (!contentId) return;
    contentViewIdRef.current = null;

    try {
      await completeContentView({ variables: { input: { contentId } } });
      client.refetchQueries({ include: [getUserProfileTgpGQL, meGQL] });
    } catch {
      // do nothing
    }
  }, [completeContentView, client]);
};
